<style scoped>
@import "./index.css";
</style>

<template>
    <div>
        <!--图片裁剪-->
        <div :class="[circle ? 'cropper-yuan' : '']">
            <img id="image" style="max-width: 100%;" src="" />
        </div>
    </div>
</template>

<script>
import 'cropperjs/dist/cropper.css';
import Cropper from 'cropperjs';
export default {
    //用props把数据传给子组件
    props: ['aspectratio','circle'],
    data:function(){
        return {
            cropper:'',
            aspectRatio:'',
            getCropper:'',
            is_crop:true
        }
    },
    created()
    {
        if(this.circle){
            this.aspectRatio = '1';
        }else{
            this.aspectRatio = this.aspectratio || '1/2';
        }
    },
    mounted:function()
    {
        let that = this;
        var image = document.querySelector('#image');
        that.cropper = new Cropper(image, {
            dragMode: 'move',
            aspectRatio: that.aspectRatio,
            autoCropArea: 0.7,
            restore: false,
            guides: false,
            center: false,
            highlight: false,
            cropBoxMovable: false,
            cropBoxResizable: false,
            toggleDragModeOnDblclick: false
        });
    },
    methods: {
        //圆
        getRoundedCanvas(sourceCanvas) {
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            var width = sourceCanvas.width;
            var height = sourceCanvas.height;

            canvas.width = width;
            canvas.height = height;
            context.imageSmoothingEnabled = true;
            context.drawImage(sourceCanvas, 0, 0, width, height);
            context.globalCompositeOperation = 'destination-in';
            context.beginPath();
            context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
            context.fill();
            return canvas;
        },
        //创建url路径
        getObjectURL(file) {
            var url = null;
            if (window.createObjectURL != undefined) {
                // basic
                url = window.createObjectURL(file);
            } else if (window.URL != undefined) {
                // mozilla(firefox)
                url = window.URL.createObjectURL(file);
            } else if (window.webkitURL != undefined) {
                // webkit or chrome
                url = window.webkitURL.createObjectURL(file);
            }
            return url;
        },
        addImg(inputDOM,fn)
        {
            let that = this;
            //每次替换图片要重新得到新的url
            if (that.cropper) {
                that.cropper.Filename = inputDOM.name;
                that.cropper.replace(that.getObjectURL(inputDOM));
                if(typeof fn == 'function') fn(that.cropper);
            }
        },
        crop()
        {
            let that = this;
            if (!that.cropper) {
                return;
            }
            if(that.is_crop){
                that.is_crop = false;
                //判断是否圆
                if(that.circle){
                    that.getCropper = that.getRoundedCanvas(that.cropper.getCroppedCanvas());
                }else{
                    that.getCropper = that.cropper.getCroppedCanvas();
                }
                // 当canvas对象的原型中没有toBlob方法的时候，手动添加该方法
                // if (!HTMLCanvasElement.prototype.toBlob) {
                //     Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
                //         value: function (callback, type, quality) {
                //             var binStr = atob(this.toDataURL(type, quality).split(',')[1]),
                //                 len = binStr.length,
                //                 arr = new Uint8Array(len);
                //             for (var i = 0; i < len; i++) {
                //                 arr[i] = binStr.charCodeAt(i);
                //             }
                //             callback(new Blob([arr], {type: type || 'image/png'}));
                //         }
                //     });
                // }
                that.updatePic(that.getCropper.toDataURL("image/*"));
                // that.getCropper.toBlob(function(blob)
                // {
                //     blob.name = that.cropper.Filename;
                //     that.updatePic(blob);
                // });
            }else{
                that.$func.msg('请稍等会...')
            }
        },
        updatePic(blob){
            let that = this;
            that.$Message.loading({
                content: '上传中...',
                duration: 0
            });
            that.$func.ajax('upImg',{
                token : that.$func.getUserInfo('token'),
                img64 : blob,
            },function(r){
                that.$Message.destroy()
                if(!r.statusCode){
                    that.$func.msg(r.message,'error');
                }else{
                    that.$emit('setpicurl',r.type);
                    that.is_crop = true;
                }
            },'','post',false)
        },
        onClose(){
            this.is_crop = true;
            this.$emit('close');
        }
    }
};
</script>
